import { z } from "zod";

export const DigitalSignatureDriverSchema = z.object({
  driverId: z.number(),
  agreementId: z.number().nullable(),
  customerId: z.number().nullable(),
  driverName: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  dateOfBirth: z.string().nullable(),
  driverType: z.number(),
  createdBy: z.coerce.string().nullable(),
  licenseNumber: z.string().nullable(),
  licenseCategory: z.string().nullable(),
  licenseExpiryDate: z.string().nullable(),
  email: z.string().nullable(),
  licenseIssueDate: z.string().nullable(),
  licenseIssueState: z.string().nullable(),
  hPhone: z.string().nullable(),
  bPhone: z.string().nullable(),
  cPhone: z.string().nullable(),
  address: z.string().nullable(),
  city: z.string().nullable(),
  stateId: z.number().nullable(),
  zipCode: z.string().nullable(),
  countryId: z.number().nullable(),
  signatureName: z.string().nullable(),
  signatureImageUrl: z.string().nullable(),
  reservationId: z.number().nullable(),
  insuranceCompany: z.string().nullable(),
  checkForDelete: z.number().nullable(),
  dateofBirth: z.string().nullable(),
  dateofBirthStr: z.string().nullable(),
  createdDate: z.string().nullable(),
  updatedDate: z.string().nullable(),
  updateBy: z.coerce.string().nullable(),
  driverLicenseNumber: z.string().nullable(),
  driverLicenseCategory: z.string().nullable(),
  driverLicenseExpiryDate: z.string().nullable(),
  isDelete: z.boolean(),
  isFromCustomer: z.boolean(),
  phone: z.string().nullable(),
  signatureImageUrlString: z.string().nullable(),
  startDate: z.string().nullable(),
  endDate: z.string().nullable(),
  referenceType: z.string().nullable(),
  referenceId: z.coerce.string().nullable(),
  countryName: z.string().nullable(),
  signatureDate: z.string().nullable(),
});
export type DigitalSignatureDriver = z.infer<
  typeof DigitalSignatureDriverSchema
>;
